import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "add-methods-dialog__option_logo-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FallbackImage = _resolveComponent("FallbackImage")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.isMethodListAssociatingDialogVisible,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isMethodListAssociatingDialogVisible) = $event)),
    title: "Add payment methods",
    "close-on-press-escape": "",
    width: "40%",
    center: "",
    "lock-scroll": false,
    onClose: _ctx.closeDialog
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        disabled: _ctx.isAvailableAssociablePaymentMethodListLoading,
        onClick: _ctx.closeDialog
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createTextVNode(" Cancel ", -1 /* CACHED */)
        ]))]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled", "onClick"]),
      _createVNode(_component_el_button, {
        type: "primary",
        disabled: !_ctx.selectedMethodList.length,
        loading: _ctx.isAvailableAssociablePaymentMethodListLoading,
        onClick: _ctx.initiateSelectedMethodListAssociation
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
          _createTextVNode(" Add ", -1 /* CACHED */)
        ]))]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled", "loading", "onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        "label-position": "top",
        disabled: _ctx.isAvailableAssociablePaymentMethodListLoading
      }, {
        default: _withCtx(() => [
          _withDirectives((_openBlock(), _createBlock(_component_el_select, {
            modelValue: _ctx.selectedMethodList,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedMethodList) = $event)),
            class: "add-methods-dialog__select",
            placeholder: "Select payment methods",
            multiple: "",
            filterable: "",
            "value-key": "billingPaymentMethodId"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableAssociablePaymentMethodList, (paymentMethod) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: paymentMethod.billingPaymentMethodId,
                  label: paymentMethod.name,
                  value: paymentMethod,
                  class: "add-methods-dialog__option"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _createVNode(_component_FallbackImage, {
                        "model-value": paymentMethod,
                        class: "add-methods-dialog__option_logo-image"
                      }, null, 8 /* PROPS */, ["model-value"])
                    ]),
                    _createTextVNode(" " + _toDisplayString(paymentMethod.name), 1 /* TEXT */)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["label", "value"]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["modelValue"])), [
            [_directive_loading, _ctx.isAvailableAssociablePaymentMethodListLoading]
          ])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue", "onClose"]))
}